import React, { useEffect, useState } from 'react';

import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import InputNumero from '../../../../components/inputs/yup/materialui/inputNumero';
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import InputRut from '../../../../components/inputs/yup/materialui/inputRut';
import InputSwitch from '../../../../components/inputs/yup/materialui/inputSwitch';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import MButton from '../../../../components/inputs/yup/materialui/mButton';

import Grid2 from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PeopleTwoToneIcon from '@mui/icons-material/PeopleTwoTone';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import EstadosCiviles from "../../../../mocks/estadosCiviles.json";
import Sexos from "../../../../mocks/sexos.json";
import { ciudadesSelect, estadoCivilSelect, BeneficioSiiSelect, Participante, EliminarParticipante } from '../../models/participantes';
import { useParticipantes } from '../../hooks/useParticipantes';
import * as Yup from "yup";
import validaRut from '../../../../utils/validaRut';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from 'react-hook-form';
import { EnumCodeudor, enumTipoParticipanteConValores, enumTipoPersona, StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import { ArgumentosCodeudorDto, Codeudor } from '../../models/codeudor';
import { useCodeudor } from '../../hooks/useCodeudor';
import Validaciones from '../../../../utils/validaciones';
import { actualizarCodeudor, guardarCodeudor } from '../../services/servicesCodeudor';
import { getListaParticipantes } from '../../services/servicesParticipantes';
import { useToast } from '../../../../hooks/useToast';
import { format } from 'rut.js';
import { AxiosResponse } from 'axios';
import ListaSegurosCodeudor from './listaSegurosCodeudor';
import { Divider } from '@mui/material';
import { ListResponseDto } from '../../../../dtos/ListResponseDto';
import { useDetalleMutuoPermissions } from '../../hooks/useDetalleMutuoPermissions';
import { DetalleMutuoPermissionGuard } from '../../../../components/auth/DetalleMutuoPermissionGuard';




interface IProps {
    dataCodeudor: Codeudor | undefined;
    ciudadesSelect: ciudadesSelect[];
    estadoCivilSelect: estadoCivilSelect[];
    beneficioSiiSelect: BeneficioSiiSelect[];
    idMutuo: number;
    setShowParticipantes: React.Dispatch<React.SetStateAction<boolean>>;
    renderizar: () => void;
    volver: () => void;
    esNuevo: boolean;
    esJuridico: boolean;
    esConyuge: boolean;
    esMutuoNormalyConComplementario: boolean;
    handleDelete: (dataDelete: EliminarParticipante) => void
    isComplementario: boolean;
    isDesactivado?: boolean;
    esVigente?: boolean;
    deudorEsBeneficiarioSii?: boolean;
}



const CodeudorForm: React.FC<IProps> = (props) => {
    const { comunaPorId, comunasSelect, comunasCorrespondecia, setComunasCorrespondecia, setComunasSelect,
        listaParticipantePorId
    } = useParticipantes();

    const { tiposDeudaCodeudorSelect, tiposDeudaCodeudor } = useCodeudor();

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [rutNew, setRutNew] = useState<string | null>(null);
    const { addToast } = useToast();
    const [participantesCache, setParticipantesCache] = useState<Participante[]>([]);

    const schemaCodeudor = Yup.object<Codeudor>().shape({
        rut: Yup.string()
            .default('')
            .nonNullable()
            .test('valida-rut', 'RUT inválido', function (value) {
                return validaRut.rutFormat(value);
            })
            .required('Campo requerido')
            .test({
                name: 'valida-rut-distinto-deudor',
                exclusive: false,
                params: {},
                message: 'RUT debe ser distinto al del resto de los participantes',
                test: async (value, { createError }) => {

                    let participantes: Participante[] = [];

                    if (participantesCache.length == 0) {
                        let resp: AxiosResponse<ListResponseDto<Participante>> = await getListaParticipantes(props.idMutuo);

                        if (resp.status == StatusCode.Ok) {
                            setParticipantesCache(await resp.data.items);
                        }
                        else {
                            return createError({ message: "No fué posible validar el RUT" })
                        }
                    }

                    participantes = participantesCache;

                    if (participantes === undefined) return createError({ message: "No fué posible validar el RUT" });

                    let rutIngresado: string = format(value, { dots: false });

                    let deudor: Participante | undefined = participantes?.find(x => x.idTipoParticipante ===
                        enumTipoParticipanteConValores.Deudor);
                    if (deudor && rutIngresado === deudor.rut) {
                        return createError({ message: "RUT no permitido, pertenece al deudor del mutuo" });
                    }

                    let rutPermitido: boolean = true;
                    participantes?.forEach((participante: Participante) => {
                        if (participante.idTipoParticipante === enumTipoParticipanteConValores.Codeudor) {
                            if (rutNew !== participante.rut && participante.rut !== props.dataCodeudor?.rut && participante.rut === rutIngresado) {
                                rutPermitido = false;
                            }
                        }

                    });

                    if (!rutPermitido)
                        return createError({ message: "RUT no permitido, ya existe un codeudor con este RUT" })

                    rutPermitido = true;
                    participantes?.forEach((participante: Participante) => {

                        if (participante.idTipoParticipante === enumTipoParticipanteConValores.Mandatario) {
                            if (participante.rut === rutIngresado) {
                                rutPermitido = false;
                            }
                        }

                    });

                    if (!rutPermitido)
                        return createError({ message: "RUT no permitido, pertenece a un mandatario" })

                    return true;
                }
            }),


        esConyuge: Yup.boolean().default(false).when(['tipoPersonaDeudor'], {
            is: (tipoPersonaDeudor: string) => { return tipoPersonaDeudor === enumTipoPersona.Natural; },
            then: (s) => s.required('Campo requerido'),
            otherwise: (s) => s.notRequired()
        }),


        apellidopaterno: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-apellido.paterno', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        apellidomaterno: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-apellido.paterno', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        nombres: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-nombres', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        fechanacimiento: Yup.date().required('Campo requerido').test('mayor-edad', 'El codeudor debe ser mayor de edad', function (value) {
            return Validaciones.esMayor18Anios(value ?? null)
        }),
        profesion: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-profesion', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        sexo: Yup.string().required('Campo requerido'),
        estadocivil: Yup.string().required('Campo requerido').test({
            name: 'valida-rut-distinto-deudor',
            exclusive: false,
            params: {},
            message: 'Estado civil no puede ser distinto al deudor',
            test: async (value, { createError }) => {
                if (props.esJuridico || !dataFormCodeudor.esConyuge)
                    return true;

                const resp: AxiosResponse<ListResponseDto<Participante>> = await getListaParticipantes(props.idMutuo);
                if (resp.status == StatusCode.Ok) {

                    const participantes: Participante[] = await resp.data.items;

                    let deudor: Participante | undefined = participantes?.find(x => x.idTipoParticipante ===
                        enumTipoParticipanteConValores.Deudor);
                    if (deudor && value !== deudor.estadoCivil) {
                        return createError({ message: "El estado civil debe ser igual al deudor" });
                    }

                    return true;
                }

                return createError({ message: "No fué posible validar el RUT" })
            }
        }),
        nacionalidad: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-nacionalidad', 'Caractéres inválidos', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),
        direccion: Yup.string().required('Campo requerido').max(100, 'Máximo 100 caracteres').test('valida-direccion', 'Caractéres inválidos', function (value) {
            return Validaciones.isDireccion(value ?? '')
        }),

        ciudadId: Yup.string().required('Campo requerido'),
        comunaId: Yup.string().required('Campo requerido'),


        telefonoparticular: Yup.string().required('Campo requerido').transform((value) => Number.isNaN(value) ? null : value)
            .max(999999999, "Máximo 9 digitos"),
        telefonocelular: Yup.string().nullable().transform((value) => Number.isNaN(value) ? null : value)
            .notRequired()
            .max(999999999, "Máximo 9 digitos"),
        telefonooficina: Yup.string().nullable().transform((value) => Number.isNaN(value) ? null : value)
            .notRequired()
            .max(999999999, "Máximo 9 digitos"),

        email: Yup.string().required('Campo requerido').test('valida-email', 'Email inválido', function (value) {
            return Validaciones.esValidoEmail(value ?? '');
        }),


        deudorEsBeneficiarioSii: Yup.boolean().nullable(),
        beneficioSiiAsignado: Yup.string().nullable().notRequired(),
        rolPropiedadBeneficioSii: Yup.string().nullable(),

        tipodeudor: Yup.string().required('Campo requerido'),

        porcentajedominio: Yup.number().nullable().transform((value) => Number.isNaN(value) ? null : value)
            .min(0, "Valor debe ser mayor o igual a 0")
            .max(100, 'Valor no debe ser mayor que 100'),

        porcentajedeudadirecta: Yup.number().required('Campo requerido').required("Campo requerido")
            .transform((value) => Number.isNaN(value) ? null : value)
            .min(0, "Valor debe ser mayor o igual a 0")
            .max(100, 'Valor no debe ser mayor que 100'),

        porcentajedeudaseguro: Yup.number().required('Campo requerido').max(100, 'Valor no debe ser mayor que 100').transform((value) => Number.isNaN(value) ? null : value),

        direccionCorrespConyuge: Yup.string()
            .nullable()
            .max(100, 'Máximo 100 caracteres')
            .when(['esConyuge', 'tipoPersonaDeudor'], {
                is: (esConyuge: boolean) => esConyuge && !props.esJuridico,
                then: s => s.required('Campo requerido'),
                otherwise: s => s.notRequired()
            }),

        comunaIdCorrespConyuge: Yup.string()
            .nullable()
            .when(['esConyuge', 'tipoPersonaDeudor'], {
                is: (esConyuge: boolean) => esConyuge && !props.esJuridico,
                then: s => s.required('Campo requerido'),
                otherwise: s => s.notRequired()
            }),

        ciudadIdCorrespConyuge: Yup.string()
            .nullable()
            .when(['esConyuge', 'tipoPersonaDeudor'], {
                is: (esConyuge: boolean) => esConyuge && !props.esJuridico,
                then: s => s.required('Campo requerido'),
                otherwise: s => s.notRequired()
            }),
    },);

    const {
        formState: { errors, isDirty, isValid },
        handleSubmit,
        control,
        setValue,
        watch,
        reset,
        trigger
    } = useForm<Codeudor>({
        defaultValues: props.dataCodeudor,
        mode: "onChange",
        resolver: yupResolver(schemaCodeudor)
    })

    const dataFormCodeudor = watch();

    const [esNuevo, setEsNuevo] = useState<boolean>(props.esNuevo);
    const [porcentajedeudaseguro, setPorcentajedeudaseguro] = useState<number>(dataFormCodeudor.porcentajedeudaseguro);
    const [rutProps, setRutProps] = useState<string>(props.dataCodeudor?.rut ?? '');
    const [cambioRut, setCambioRut] = useState<boolean>(false);
    const { permisoCarteraInfo, permisoCarteraContacto } = useDetalleMutuoPermissions(props.esVigente);

    useEffect(() => {
        tiposDeudaCodeudor();
    }, [])

    useEffect(() => {
        setPorcentajedeudaseguro(dataFormCodeudor.porcentajedeudaseguro);
    }, [dataFormCodeudor.porcentajedeudaseguro])

    useEffect(() => {
        if (props.dataCodeudor?.ciudadId)
            comunaPorId(props.dataCodeudor?.ciudadId);

        if (props.dataCodeudor?.ciudadIdCorrespConyuge)
            comunaPorId(props.dataCodeudor?.ciudadIdCorrespConyuge, true);

        reset(props.dataCodeudor);
    }, [props.dataCodeudor, reset])

    const handleCancelarEdicionClick = () => {
        if (esNuevo) {
            handleCancelarAgregarClick();
            return;
        }

        if (isDirty) {
            setModalConfirmacion({
                show: true,
                title: "Hay cambios sin guardar",
                message: "¿Desea abandonar la edición?",
                metodo: () => {
                    setIsEditing(false);
                    reset();
                },
            });
        }
        else {
            setIsEditing(false);
            reset();
        }
    }

    const handleCancelarAgregarClick = () => {

        if (isDirty) {
            setModalConfirmacion({
                show: true,
                title: "Hay cambios sin guardar",
                message: "¿Desea abandonar el ingreso?",
                metodo: () => {
                    props.setShowParticipantes(true);
                    setIsEditing(false);
                    props.volver();
                    reset();
                },
            });
        }
        else {
            props.setShowParticipantes(true);
            setIsEditing(false);
            props.volver();
            reset();
        }
    }

    const handleCiudadComuna = async (id: string | null, esCorrespondencia: boolean) => {

        if (esCorrespondencia) {
            setValue('comunaIdCorrespConyuge', '');
            setComunasCorrespondecia([]);
        } else {
            setValue('comunaId', '');
            setComunasSelect([]);
        }

        trigger("comunaId");
        trigger("comunaIdCorrespConyuge");

        if (id) {
            await comunaPorId(id, esCorrespondencia);
        }
    }

    async function onSubmit(data: Codeudor) {

        const dataRequest: ArgumentosCodeudorDto = {
            rutCodeudor: format(rutProps, { dots: false }),
            mutuoId: props.idMutuo,
            rutModificar: format(data.rut, { dots: false }),
            nombres: data.nombres,
            apellidoPaterno: data.apellidopaterno,
            apellidoMaterno: data.apellidomaterno,
            telefonoParticular: data.telefonoparticular,
            telefonoOficina: data.telefonooficina,
            telefonoCelular: data.telefonocelular,
            fechaNacimiento: data.fechanacimiento,
            estadoCivil: data.estadocivil,
            profesion: data.profesion,
            sexo: data.sexo,
            tipoDeudor: data.tipodeudor,
            porcentajeDeudaDirecta: data.porcentajedeudadirecta,
            porcentajeDeudaSeguro: data.porcentajedeudaseguro,
            nacionalidad: data.nacionalidad,
            email: data.email,
            porcentajeDominio: data.porcentajedominio,
            esConyuge: data.esConyuge,
            beneficioSiiAsignado: data.beneficioSiiAsignado,
            rolPropiedadBeneficioSii: data.rolPropiedadBeneficioSii,
            direccion: data.direccion,
            comunaId: data.comunaId,
            ciudadId: data.ciudadId,
            direccionCorrespConyuge: data.direccionCorrespConyuge,
            comunaCorrespIdConyuge: data.comunaIdCorrespConyuge,
            ciudadCorrespIdConyuge: data.ciudadIdCorrespConyuge,
        };

        try {

            const response: AxiosResponse = esNuevo
                ? await guardarCodeudor(dataRequest)
                : await actualizarCodeudor(dataRequest);

            if (response?.status == StatusCode.Ok) {
                addToast({
                    mostrar: true,
                    titulo: 'Confirmación',
                    tipo: 'Success',
                    mensaje: esNuevo
                        ? 'Datos creados correctamente'
                        : 'Datos modificados correctamente'
                });

                if (esNuevo)
                    setEsNuevo(false);

                setRutNew(format(dataFormCodeudor.rut, { dots: false }));

                setIsEditing(false);
                reset(dataFormCodeudor);
                setCambioRut(true)
                props.renderizar();
            }
        } catch (error) {
            console.error('Error ' + error);
        }
    }

    useEffect(() => {
        if (cambioRut) {
            setRutProps(dataFormCodeudor.rut);
            setCambioRut(false);
        }

    }, [cambioRut])

    useEffect(() => {
        if (!dataFormCodeudor.esConyuge) {
            setValue('comunaIdCorrespConyuge', '');
            setValue('ciudadIdCorrespConyuge', '');
            setValue('direccionCorrespConyuge', '');
        } else {
            trigger("comunaIdCorrespConyuge");
            trigger('ciudadIdCorrespConyuge');
            trigger('direccionCorrespConyuge');
        }
        trigger('estadocivil');

    }, [dataFormCodeudor.esConyuge])

    useEffect(() => {
        if (props.esNuevo) {
            setIsEditing(true);
            trigger();
        } else {
            setIsEditing(false);
        }

    }, [props.esNuevo])

    const eliminarCodeudor = async () => {
        const data: EliminarParticipante = {
            idTipoParticipante: enumTipoParticipanteConValores.Codeudor,
            rut: dataFormCodeudor.rut ?? props.dataCodeudor?.rut,
            nombre: `${dataFormCodeudor.nombres} ${dataFormCodeudor.apellidopaterno} ${dataFormCodeudor.apellidomaterno}`
        }
        await props.handleDelete(data);
    }

    const isReadonlyWithPermissionContacto = () => {
        // Si NO es vigente (Bandeja), NO valida permisos
        if (!props.esVigente) return !isEditing;

        // Si ES vigente (Cartera), valida permiso Cartera_editar_contacto
        return !isEditing || !permisoCarteraContacto;
    }
    const isReadonlyWithPermission = () => {
        // Si NO es vigente (Bandeja), NO valida permisos
        if (!props.esVigente) return !isEditing && !esNuevo;

        // Si ES vigente (Cartera), valida permiso
        return !isEditing || !permisoCarteraInfo;
    }
    const isReadonlyWithPermissionIsEditingOnly = () => {
        if (!props.esVigente) return !isEditing;

        return !isEditing || !permisoCarteraInfo;
    }

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
            <form onSubmit={handleSubmit(onSubmit)}>
                {!isEditing ?
                    <Grid2 container spacing={2} alignItems="center">
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <Typography variant="h4">Codeudor</Typography>
                        </Grid2>
                        <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                            {!props.isComplementario && (
                                <>
                                    <DetalleMutuoPermissionGuard
                                        esVigente={props.esVigente}
                                        permissions={[TipoFuncionalidad.Bandeja_editar]}>

                                        <MButton variant="contained" color="error" disabled={props.isDesactivado} onClick={async () => { await eliminarCodeudor(); }} startIcon={<DeleteTwoToneIcon />}>
                                            Eliminar
                                        </MButton>
                                    </DetalleMutuoPermissionGuard>
                                    <DetalleMutuoPermissionGuard
                                        esVigente={props.esVigente}
                                        permissions={[TipoFuncionalidad.Bandeja_editar, TipoFuncionalidad.Cartera_editar_info, TipoFuncionalidad.Cartera_editar_contacto]}>

                                        <MButton variant="contained" color="primary" disabled={props.isDesactivado} onClick={() => { setIsEditing(true); trigger(); }} startIcon={<EditTwoToneIcon />}>
                                            Editar
                                        </MButton>
                                    </DetalleMutuoPermissionGuard>
                                </>
                            )}
                            <MButton variant="contained" color="primary" onClick={() => { props.setShowParticipantes(true); setIsEditing(false); props.volver(); }} startIcon={<PeopleTwoToneIcon />}>
                                Listado participantes
                            </MButton>
                        </Grid2>
                    </Grid2>
                    :
                    <Grid2 container spacing={2} alignItems="center">
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <Typography variant="h4">Codeudor</Typography>
                        </Grid2>
                        <DetalleMutuoPermissionGuard
                            esVigente={props.esVigente}
                            permissions={[TipoFuncionalidad.Bandeja_editar, TipoFuncionalidad.Cartera_editar_info, TipoFuncionalidad.Cartera_editar_contacto]}>

                            <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                                <MButton
                                    type="submit"
                                    variant='contained'
                                    color="primary"
                                    disabled={!(isDirty && isValid)}
                                    onClick={() => { setIsEditing(true); }}
                                    startIcon={<SaveOutlinedIcon />}
                                >
                                    Guardar
                                </MButton>
                                <MButton
                                    type="button"
                                    variant='contained'
                                    color="inherit"
                                    onClick={() => { handleCancelarEdicionClick(); }}
                                    startIcon={<CloseOutlinedIcon />}>
                                    Cancelar
                                </MButton>
                            </Grid2>
                        </DetalleMutuoPermissionGuard>
                    </Grid2>
                }

                <Grid2 sx={{ mt: 2, mb: 3 }}>

                    <Card raised >
                        <CardContent>
                            <Typography className='card-title' variant="h6" gutterBottom>
                                Datos Personales
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                                <Grid2 size={3}>
                                    <InputRut
                                        label="RUT"
                                        name="rut"
                                        control={control}
                                        error={errors.rut}
                                        readonly={!isEditing || (!esNuevo && props.esVigente)}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Apellido paterno"
                                        name="apellidopaterno"
                                        control={control}
                                        error={errors.apellidopaterno}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Apellido materno"
                                        name="apellidomaterno"
                                        control={control}
                                        error={errors.apellidomaterno}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>

                                {(!props.esJuridico && !props.esConyuge) &&
                                    <Grid2 size={3}>
                                        <InputSwitch
                                            name="esConyuge"
                                            control={control}
                                            label="Cónyuge"
                                            error={errors.esConyuge}
                                            styleLabel={{ fontSize: 17 }}
                                            disabled={!isEditing}
                                        />
                                    </Grid2>
                                }

                                <Grid2 size={3}>
                                    <InputText
                                        label="Nombres"
                                        name="nombres"
                                        control={control}
                                        error={errors.nombres}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputFecha
                                        label='Fecha nacimiento'
                                        name="fechanacimiento"
                                        control={control}
                                        fecha={dataFormCodeudor.fechanacimiento ?? undefined}
                                        error={errors.fechanacimiento}
                                        esReadOnly={isReadonlyWithPermission()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputText
                                        label="Profesión o actividad"
                                        name="profesion"
                                        control={control}
                                        error={errors.profesion}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Sexo"
                                        name={'sexo'}
                                        control={control}
                                        options={Sexos}
                                        error={errors.sexo}
                                        disabled={isReadonlyWithPermission()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Estado civil y régimen matrimonial"
                                        name={'estadocivil'}
                                        control={control}
                                        options={EstadosCiviles}
                                        error={errors.estadocivil}
                                        disabled={isReadonlyWithPermission()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputText
                                        label="Nacionalidad"
                                        name={'nacionalidad'}
                                        control={control}
                                        error={errors.nacionalidad}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>

                <Grid2 sx={{ mt: 2, mb: 3 }}>

                    <Card raised >
                        <CardContent>
                            <Typography className='card-title' variant="h6" gutterBottom>
                                Contacto
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Teléfono particular"
                                        name="telefonoparticular"
                                        control={control}
                                        readonly={isReadonlyWithPermissionContacto()}
                                        minValue={0}
                                        maxValue={999999999}
                                        error={errors.telefonoparticular}
                                        prefix='+56'
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Teléfono celular"
                                        name="telefonocelular"
                                        control={control}
                                        readonly={isReadonlyWithPermissionContacto()}
                                        minValue={0}
                                        maxValue={999999999}
                                        error={errors.telefonocelular}
                                        prefix='+56'
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Teléfono oficina"
                                        name="telefonooficina"
                                        control={control}
                                        readonly={isReadonlyWithPermissionContacto()}
                                        minValue={0}
                                        maxValue={999999999}
                                        error={errors.telefonooficina}
                                        prefix='+56'
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputText
                                        label="Email"
                                        name="email"
                                        control={control}
                                        error={errors.email}
                                        readonly={isReadonlyWithPermissionContacto()}
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>

                <Grid2 sx={{ mt: 2, mb: 3 }}>

                    <Card raised >
                        <CardContent>

                            {(!props.esJuridico && dataFormCodeudor.esConyuge) &&

                                <>

                                    <Typography className='card-title' variant="h6" gutterBottom>
                                        Dirección correspondencia cónyuge
                                    </Typography>

                                    <Grid2 container spacing={2} sx={{ mt: 2 }}>

                                        <Grid2 size={3}>
                                            <InputText
                                                label="Dirección"
                                                name="direccionCorrespConyuge"
                                                control={control}
                                                error={errors.direccionCorrespConyuge}
                                                readonly={isReadonlyWithPermissionIsEditingOnly()}
                                            />
                                        </Grid2>

                                        <Grid2 size={3}>
                                            <InputSelect
                                                label="Ciudad"
                                                name={'ciudadIdCorrespConyuge'}
                                                control={control}
                                                options={props.ciudadesSelect}
                                                error={errors.ciudadIdCorrespConyuge}
                                                onChange={(value) => handleCiudadComuna(value ?? '', true)}
                                                disabled={isReadonlyWithPermissionIsEditingOnly()}
                                            ></InputSelect>
                                        </Grid2>

                                        <Grid2 size={3}>
                                            <InputSelect
                                                label="Comuna"
                                                name={'comunaIdCorrespConyuge'}
                                                control={control}
                                                options={comunasCorrespondecia}
                                                error={errors.comunaIdCorrespConyuge}
                                                disabled={isReadonlyWithPermissionIsEditingOnly()}
                                            ></InputSelect>
                                        </Grid2>
                                    </Grid2>

                                </>

                            }

                            <Typography className='card-title' variant="h6" gutterBottom>
                                Dirección particular
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>


                                <Grid2 size={3}>
                                    <InputText
                                        label="Dirección"
                                        name="direccion"
                                        control={control}
                                        error={errors.direccion}
                                        readonly={isReadonlyWithPermissionIsEditingOnly()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Ciudad"
                                        name={'ciudadId'}
                                        control={control}
                                        options={props.ciudadesSelect}
                                        error={errors.ciudadId}
                                        onChange={(value) => handleCiudadComuna(value ?? '', false)}
                                        disabled={isReadonlyWithPermissionIsEditingOnly()}
                                    ></InputSelect>
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Comuna"
                                        name={'comunaId'}
                                        control={control}
                                        options={comunasSelect}
                                        error={errors.comunaId}
                                        disabled={isReadonlyWithPermissionIsEditingOnly()}
                                    ></InputSelect>
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>

                <Grid2 sx={{ mt: 2, mb: 3 }}>
                    <Card raised >
                        <CardContent>
                            <Typography className='card-title' variant="h6" gutterBottom>
                                Datos deuda
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Tipo"
                                        name="tipodeudor"
                                        control={control}
                                        options={tiposDeudaCodeudorSelect}
                                        error={errors.tipodeudor}
                                        disabled={isReadonlyWithPermissionIsEditingOnly()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Deuda directa"
                                        name="porcentajedeudadirecta"
                                        control={control}
                                        readonly={isReadonlyWithPermissionIsEditingOnly()}
                                        // maxValue={100}
                                        decimales={1}
                                        error={errors.porcentajedeudadirecta}
                                        suffix='%'
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Deuda seguro"
                                        name="porcentajedeudaseguro"
                                        control={control}
                                        readonly={isReadonlyWithPermissionIsEditingOnly()}
                                        // maxValue={100}
                                        decimales={1}
                                        error={errors.porcentajedeudaseguro}
                                        suffix='%'
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Porcentaje dominio"
                                        name="porcentajedominio"
                                        control={control}
                                        readonly={isReadonlyWithPermissionIsEditingOnly()}
                                        decimales={0}
                                        maxValue={100}
                                        error={errors.porcentajedominio}
                                        suffix='%'
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Beneficio tributario"
                                        name="beneficioSiiAsignado"
                                        control={control}
                                        options={props.beneficioSiiSelect}
                                        error={errors.beneficioSiiAsignado}
                                        clearable={true}
                                        onChange={(value) => { if (!value) setValue('rolPropiedadBeneficioSii', '') }}
                                        disabled={(dataFormCodeudor.tipodeudor != EnumCodeudor.CodeudorTitular &&
                                            dataFormCodeudor.tipodeudor != EnumCodeudor.CoTitular) ||
                                            (dataFormCodeudor.deudorEsBeneficiarioSii ?? props.deudorEsBeneficiarioSii) || isReadonlyWithPermission()}
                                    />
                                </Grid2>

                                <Grid2 size={3}>
                                    <InputText
                                        label="ROL"
                                        name="rolPropiedadBeneficioSii"
                                        control={control}
                                        error={errors.rolPropiedadBeneficioSii}
                                        readonly={
                                            (dataFormCodeudor.tipodeudor != EnumCodeudor.CodeudorTitular &&
                                                dataFormCodeudor.tipodeudor != EnumCodeudor.CoTitular) ||
                                            (dataFormCodeudor.deudorEsBeneficiarioSii ?? props.deudorEsBeneficiarioSii) ||
                                            (!dataFormCodeudor.beneficioSiiAsignado) || isReadonlyWithPermission()}
                                    />
                                </Grid2>


                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>

            </form >

            {!esNuevo &&
                <Card raised>
                    <CardContent className="card-body">
                        <Typography className='card-title' variant="h6" gutterBottom>
                            Datos Seguros
                        </Typography>
                        <ListaSegurosCodeudor idMutuo={props.idMutuo}
                            rut={format(dataFormCodeudor.rut, { dots: false })}
                            porcentajedeudaseguro={porcentajedeudaseguro} esVigente={props.esVigente}></ListaSegurosCodeudor>

                    </CardContent>
                </Card>
            }

        </>
    );
};

export default CodeudorForm;


